import { GridItem, Box } from '@chakra-ui/react';
import { Checkbox } from '@/components/v4';
import { CRUD_FIELDS } from './constants';

// Sidebar's thumb is tuned for its dark bg (barely-visible white @10%); this needs contrast in both themes.
export const renderThumb = (darkMode) =>
    function ThumbWithContrast({ style, ...rest }) {
        return (
            <Box
                style={{
                    ...style,
                    borderRadius: 15,
                    background: darkMode
                        ? 'rgba(255,255,255,.3)'
                        : 'rgba(0,0,0,.25)',
                }}
                {...rest}
            />
        );
    };

// Shared CRUD checkbox cells for both the flat (single-scope) and accordion (multi-scope) layouts.
export const renderCrudCheckboxes = ({
    permissionName,
    value,
    scopeNumber,
    disabled,
    submitData,
    onChange,
    mb,
}) =>
    CRUD_FIELDS.map((mode) => (
        <GridItem colSpan={2} key={`${permissionName}-${scopeNumber}-${mode}`}>
            <Checkbox
                isDisabled={disabled}
                mb={mb}
                isChecked={
                    submitData[value[scopeNumber]?.id]?.[mode] ??
                    value[scopeNumber]?.[mode] ??
                    false
                }
                onChange={(e) =>
                    onChange({ e, mode, scopeNumber, permissionName })
                }
                data-walkthroughid={`/permissions/permissionsTab/${permissionName}/${mode}`}
            />
        </GridItem>
    ));
